import { useEffect, useState } from "react";
import {
  getAnalyticsConsent,
  trackSpaPageView,
  updateAnalyticsConsent,
} from "@/lib/analytics";

export default function AnalyticsConsent() {
  const [choice, setChoice] = useState(null);

  useEffect(() => {
    const savedChoice = getAnalyticsConsent();
    setChoice(savedChoice);
    if (savedChoice) {
      updateAnalyticsConsent(savedChoice);
      if (savedChoice === "granted") {
        trackSpaPageView();
      }
    }
  }, []);

  const chooseConsent = (nextChoice) => {
    updateAnalyticsConsent(nextChoice);
    if (nextChoice === "granted") {
      trackSpaPageView();
    }
    setChoice(nextChoice);
  };

  if (choice) {
    return null;
  }

  return (
    <aside
      className="relative z-50 mx-4 mt-3 max-w-xl border border-[#1A3323]/15 bg-[#F7F4EA]
        p-4 shadow-xl sm:fixed sm:inset-x-4 sm:bottom-4 sm:mx-auto sm:mt-0 sm:flex
        sm:items-center sm:gap-5"
      aria-label="Pilihan analitik"
      data-testid="analytics-consent-banner"
    >
      <p className="text-sm leading-relaxed text-[#1A3323]/75" data-testid="analytics-consent-copy">
        Kami memakai analitik untuk memahami penggunaan situs dan memperbaiki pengalaman komunitas.
      </p>
      <div className="mt-3 flex shrink-0 gap-2 sm:mt-0">
        <button
          type="button"
          className="min-h-10 border border-[#1A3323]/20 px-3 text-sm font-bold text-[#1A3323]
            transition-colors hover:bg-[#E3EDD9] focus-visible:outline-none focus-visible:ring-2
            focus-visible:ring-[#3D6F4B]"
          onClick={() => chooseConsent("denied")}
          data-testid="analytics-consent-decline-button"
        >
          Tidak sekarang
        </button>
        <button
          type="button"
          className="min-h-10 bg-[#1A3323] px-3 text-sm font-bold text-[#FDFCF8]
            transition-colors hover:bg-[#3D6F4B] focus-visible:outline-none focus-visible:ring-2
            focus-visible:ring-[#3D6F4B] focus-visible:ring-offset-2"
          onClick={() => chooseConsent("granted")}
          data-testid="analytics-consent-accept-button"
        >
          Setujui
        </button>
      </div>
    </aside>
  );
}